import { ICON__magnifying_glass } from '@/assets/icons_fa';
import { EKeyCode } from '@/enums/e_key_code';
import { ENUM__page_type } from '@/enums/ENUM__page_type';
import { Key } from '@/enums/key';
import { use_slice_search, use_slice_ui, use_slice_workspace } from '@/hooks/store/use_slices';
import i18n_base_ui from '@/locales/keys/i18n_base_ui.json';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { ENUM__workspace_entity_feature } from '@shared/dto/+workspace/workspace_entity/_enums/ENUM__workspace_entity_feature';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { BUTTON__navigation_desktop } from '../desktop/BUTTON__navigation_desktop';
import { ButtonNavigationMobile } from '../mobile/ButtonNavigationMobile';
import { PROPS__button_navigation } from './PROPS__button_navigation';

export function ButtonNavigationSearch() {
  const { t } = useTranslation(ENUM__i18n_namespace.BASE_UI);

  const { global_is_mobile, global_need_show_first_animation } = use_slice_ui(['global_is_mobile', 'global_need_show_first_animation']);
  const { workspace_current, current_workspace_user } = use_slice_workspace(['workspace_current', 'current_workspace_user']);
  const { search_history_map } = use_slice_search(['search_history_map']);

  const is_visible = useMemo(() => get_is_visible(), [current_workspace_user, workspace_current, search_history_map]);

  const shortcut_key = Key.Q;
  const shortcut_key_codes = [EKeyCode.Q];

  /*
   * METHODS
   */

  function get_is_visible() {
    let user_permitted_to_view_entities = current_workspace_user.is_feature_pertmitted(ENUM__workspace_entity_feature.ENTITY_SEARCH_VIEW);

    let workspace_current_has_shared_entity =
      Array.from(search_history_map.values()).filter(item => item.workspace_id == workspace_current._id && item.is_shared).length > 0;

    return user_permitted_to_view_entities || workspace_current_has_shared_entity;
  }

  /*
   * HTML
   */

  let props: PROPS__button_navigation = {
    global_need_show_first_animation,
    page_type: ENUM__page_type.SEARCH_WITHOUT_PARAMS,
    tooltip_title: t(i18n_base_ui.sidebar_navigation.tabs.search.tooltip.title, { shortcut_key: shortcut_key.toUpperCase() }),
    title: t(i18n_base_ui.sidebar_navigation.tabs.search.title),
    Icon: ICON__magnifying_glass,
  };

  if (!is_visible) return null;

  return global_is_mobile ? <ButtonNavigationMobile {...props} /> : <BUTTON__navigation_desktop {...props} {...{ shortcut_key_codes }} />;
}
